// extracted by mini-css-extract-plugin
export default {"promoContainer":"PromoItem_promoContainer__sfhpP","promoImage":"PromoItem_promoImage__QVrVA"};